module.exports = __webpack_public_path__ + "img/friendly-pool.10ae1dca.jpg";